var O=Object.defineProperty,j=Object.defineProperties;var x=Object.getOwnPropertyDescriptors;var y=Object.getOwnPropertySymbols;var A=Object.prototype.hasOwnProperty,F=Object.prototype.propertyIsEnumerable;var u=(i,t,o)=>t in i?O(i,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):i[t]=o,d=(i,t)=>{for(var o in t||(t={}))A.call(t,o)&&u(i,o,t[o]);if(y)for(var o of y(t))F.call(t,o)&&u(i,o,t[o]);return i},m=(i,t)=>j(i,x(t));(function(i,t){typeof exports=="object"&&typeof module!="undefined"?t(exports,require("styled-components")):typeof define=="function"&&define.amd?define(["exports","styled-components"],t):(i=typeof globalThis!="undefined"?globalThis:i||self,t(i.frame={},i.styled))})(this,function(i,t){"use strict";function o(e){return e&&typeof e=="object"&&"default"in e?e:{default:e}}var b=o(t),a={exports:{}},h="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",v=h,g=v;function p(){}function c(){}c.resetWarningCache=p;var T=function(){function e(w,C,I,N,z,k){if(k!==g){var l=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw l.name="Invariant Violation",l}}e.isRequired=e;function n(){return e}var r={array:e,bigint:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:n,element:e,elementType:e,instanceOf:n,node:e,objectOf:n,oneOf:n,oneOfType:n,shape:n,exact:n,checkPropTypes:c,resetWarningCache:p};return r.PropTypes=r,r};a.exports=T();var R=a.exports;function f(e){return Array.isArray(e)&&e.length===2&&e.every(Number.isFinite)||typeof e=="string"&&/^\d{1,1000} {0,1}\/ {0,1}\d{1,1000}$/.test(e)}function _(e){return Array.isArray(e)?e.join("/"):e}function S(e){return f(e)?_(e):void 0}const s=b.default.div.attrs(({ratio:e,style:n})=>{const r=S(e);return{"data-bedrock-frame":"",style:m(d({},n),{"--ratio":r})}})`
  box-sizing: border-box;
  display: block;
  inline-size: 100%;
  position: relative;
  overflow: hidden;

  &[style*="--ratio"] {
    aspect-ratio: var(--ratio);
  }

  > * {
    position: absolute;

    inset-block-start: 0;
    inset-block-end: 0;
    inset-inline-start: 0;
    inset-inline-end: 0;

    inset-block: 0;
    inset-inline: 0;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  > :is(img, video) {
    inline-size: 100%;
    block-size: 100%;
    size: 100%;

    object-fit: cover;
    object-position: ${e=>typeof e.position=="string"?e.position:"50%"};
  }
`;s.displayName="Frame";function P({ratio:e},n){if(e===void 0)return;f(e)||console.error(`${n} needs to be an array of two numbers or a string in the form of "width/height"`)}s.propTypes={ratio:P,position:R.string},i.Frame=s,Object.defineProperties(i,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}})});
